import { useEffect } from 'react';

// The static manifest's start_url is the site root, so a home-screen shortcut of the scan page
// opens "/" and lands on login. While the scan page is open, point the manifest at this page instead.
export function useScanPageManifest(eventName, eventId) {
  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]');
    if (!link || !eventId) return undefined;

    const { origin, pathname, search } = window.location;
    const name = eventName ? `${eventName} Scanner` : 'Event Scanner';
    const manifest = {
      id: pathname,
      name,
      short_name: name.length > 12 ? 'Scanner' : name,
      start_url: `${origin}${pathname}${search}`,
      scope: `${origin}${pathname}`,
      display: 'standalone',
      theme_color: '#000000',
      background_color: '#ffffff',
      icons: [
        { src: `${origin}/fevicon.png`, sizes: '64x64', type: 'image/png' },
        { src: `${origin}/logo.png`, sizes: '400x400', type: 'image/png' },
      ],
    };

    const originalHref = link.getAttribute('href');
    const blobUrl = URL.createObjectURL(new Blob([JSON.stringify(manifest)], { type: 'application/manifest+json' }));
    link.setAttribute('href', blobUrl);

    return () => {
      link.setAttribute('href', originalHref);
      URL.revokeObjectURL(blobUrl);
    };
  }, [eventName, eventId]);
}
